// angular imports
import { Component, EventEmitter, Injector, Input, OnInit, Output, ViewChild } from '@angular/core';

// devextreme imports
import { DxPopupComponent } from 'devextreme-angular';
import notify from 'devextreme/ui/notify';

// component imports
import { WorkOrderBaseComponent } from '../../../_base/work-order-base-component';

// model imports
import { AddWorkOrderVendorParametersDto } from '../../../_models/add-work-order-vendor-parameters-dto';

// constant imports
import { Constants } from '../../../../_constants/constants';
import { ValidationFormatConstants } from '../../../../_constants/validation-format-constants';
import { MessageInterval } from '../../../../_constants/messages-intervals';
import { StringFormatConstants } from '../../../../_constants/string-format-constants';

@Component({
    selector: 'app-add-temporary-vendor',
    templateUrl: './add-temporary-vendor.component.html',
    styleUrls: ['./add-temporary-vendor.component.scss']
})
export class AddTemporaryVendorComponent extends WorkOrderBaseComponent implements OnInit {
    @ViewChild('addTemporaryVendorPopup', { static: false }) addTemporaryVendorPopup: DxPopupComponent;

    @Input() communityId: number;
    @Input() workOrderId: number;

    @Output() onClose = new EventEmitter<boolean>();

    visible = false;
    defaulLabelLocation: string;
    isTempVendorAdded = false;

    workOrderVendor: AddWorkOrderVendorParametersDto;
    phoneMaskRules = ValidationFormatConstants.phoneRules;
    phonePattern = ValidationFormatConstants.phonePattern;
    emailPattern = ValidationFormatConstants.emailPattern;
    phoneMask = StringFormatConstants.phoneMask;

    constructor(protected readonly injector: Injector) {
        super(injector);
    }

    ngOnInit() {
        this.defaulLabelLocation = Constants.defaultFormLabelLocation;
        this.workOrderVendor = new AddWorkOrderVendorParametersDto();
        this.show();
    }

    show(): void {
        this.visible = true;
    }

    onPopupShown(): void {
        this.addTemporaryVendorPopup.instance.repaint();
    }

    onPopupClose(): void {
        this.closeAddTemporaryVendor();
    }

    onSaveClick(): void {
        this.workOrderVendor.communityId = this.communityId;
        this.workOrderVendor.workOrderId = this.workOrderId;
        this.workOrderHelperService.showLoading();
        this.workOrderService.addTemporaryVendor(this.workOrderVendor).subscribe(
            (result) => {
                notify('Temporary Vendor added successfully.', 'Success', MessageInterval.successMsgInterval);
                this.workOrderHelperService.hideLoading();
                this.isTempVendorAdded = true;
                this.closeAddTemporaryVendor();
            },
            (error) => {
                this.errorService.displayError(error);
                this.workOrderHelperService.hideLoading();
            }
        );
    }

    private closeAddTemporaryVendor(): void {
        this.visible = false;
        this.onClose.emit(this.isTempVendorAdded);
    }
}
